import { create } from "zustand";

interface TemplateDetailStore {
  previousBody: string | null;
  previousSubject: string | null;
  setPrevious: (body: string, subject: string | null) => void;
  clear: () => void;
}

export const useTemplateDetailStore = create<TemplateDetailStore>((setState) => ({
  previousBody: null,
  previousSubject: null,

  setPrevious: (body, subject) => {
    setState({ previousBody: body, previousSubject: subject });
  },

  clear: () => {
    setState({ previousBody: null, previousSubject: null });
  },
}));
